<!-- 商户管理 -->
<template>
  <div class="content">
    <div class="bodycontent">
      <div class="option">
        <el-radio-group v-model="menus" @change="changeRadio">
          <el-radio-button label="商家分类"></el-radio-button>
          <el-radio-button label="商家分组"></el-radio-button>
          <el-radio-button label="商户等级"></el-radio-button>
          <el-radio-button label="入驻管理"></el-radio-button>
        </el-radio-group>
      </div>
      <div class="edit_button">
        <el-button
          type="primary"
          size="medium"
          icon="el-icon-plus"
          v-if="menus == '商家分类'"
          @click="addShopClass"
          >添加商家分类</el-button
        >
        <el-button
          type="primary"
          size="medium"
          icon="el-icon-plus"
          v-if="menus == '商家分组'"
          @click="addShopGroup"
          >添加商家分组</el-button
        >
        <el-button
          type="primary"
          size="medium"
          icon="el-icon-plus"
          v-if="menus == '商户等级'"
          @click="addShopLevel"
          >添加商户等级</el-button
        >
      </div>
      <!-- 商家分类 -->
      <ClassTable
        :tableData="classList"
        v-if="menus == '商家分类'"
        @delItem="delClassItem"
      ></ClassTable>
      <!-- 商家分组 -->
      <GroupTable
        :tableData="groupList"
        v-if="menus == '商家分组'"
        @delItem="delGroupItem"
      ></GroupTable>
      <!-- 商户等级 -->
      <LevelTable
        :tableData="levelList"
        v-if="menus == '商户等级'"
        @delItem="delLevelItem"
      ></LevelTable>
      <!-- 入驻管理 -->
      <JoinSet v-show="menus == '入驻管理'"></JoinSet>
      <!-- 分页按钮 -->
      <div class="Otherpage" v-if="menus != '入驻管理'">
        <div class="changePage">
          <div @click="upPage" class="btnColor">
            <span>上一页</span>
          </div>
          <div>
            <span>{{ page }}</span>
          </div>
          <div @click="downPage" class="btnColor">
            <span>下一页</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ClassTable from "./tables/classTable";
import GroupTable from "./tables/groupTable";
import LevelTable from "./tables/levelTable";
import JoinSet from "./forms/joinSet";
import { mapGetters } from "vuex";
import {
  ClassList,
  DelClass,
  GroupList,
  DelGroup,
  LevelList,
  DelLevel,
  MerchTypeList,
  DelMerchType
} from "@/api/merchant";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  components: {
    ClassTable,
    GroupTable,
    LevelTable,
    JoinSet
  },
  data() {
    return {
      menus: "商家分类",
      classList: [], //商户分类列表
      groupList: [], //商户分组列表
      levelList: [], //商户等级列表
      page: 1,
      params: {}
    };
  },
  mounted() {
    this.$store.commit("SET_STATE", "2");
    this.params = {
      token: this.token,
      app_id: this.app_id
    };
    this.getClassList();
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("SET_STATE", "1");
    next();
  },
  methods: {
    changeRadio(val) {
      console.log(val);
      this.page = 1;
      if (val == "商家分类") {
        this.getClassList();
      } else if (val == "商家分组") {
        this.getGroupList();
      } else if (val == "商户等级") {
        this.getLevelList();
      } else if (val == "入驻管理") {
        
      }
    },
    //获取商家分类列表
    getClassList() {
      var data = Object.assign({}, this.params);
      MerchTypeList(data).then(res => {
        this.classList = res.data;
        this.classList.forEach(item=>{
          this.setStatus(item);
        })
      });
    },
    //遍历子元素
    setStatus(item){
      item.show_Status = item.status == 1? '开启':'禁用'
      if(item.children.length){
        item.children.forEach(every=>{
          this.setStatus(every);
        })
      }
    },
    //删除商家分类
    delClassItem(sid) {
      var data = {
        token: this.token,
        id: sid
      }
      DelMerchType(data).then(res => {
        if (res.code == "1") {
          this.$message({
            type: "success",
            message: res.msg
          });
          this.getClassList();
        }else{
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    },
    //获取商家分组
    getGroupList() {
      var data = Object.assign({}, this.params);
      data.page = this.page;
      GroupList(data).then(res => {
        this.groupList = res.data;
      });
    },
    //删除商家分组
    delGroupItem(id) {
      var data = Object.assign({}, this.params);
      data.id = id;
      DelGroup(data).then(res => {
        if (res.code == "1") {
          this.$message({
            type: "success",
            message: res.msg
          });
          this.getGroupList();
        }
      });
    },
    //获取商家等级列表
    getLevelList() {
      var data = Object.assign({}, this.params);
      data.page = this.page;
      LevelList(data).then(res => {
        this.levelList = res.data;
      });
    },
    //删除商家等级
    delLevelItem(id) {
      var data = Object.assign({}, this.params);
      data.id = id;
      DelLevel(data).then(res => {
        if (res.code == "1") {
          this.$message({
            type: "success",
            message: res.msg
          });
          this.getLevelList();
        }
      });
    },
    addShopClass() {
      this.$router.push({
        path: "shopClassForm"
      });
    },
    addShopGroup() {
      this.$router.push({
        path: "shopGroupForm"
      });
    },
    addShopLevel() {
      this.$router.push({
        path: "shopLevelForm"
      });
    },
    upPage() {
      // 上一页
      this.page--;
      if (this.page == 0) {
        this.page = 1;
        this.getOrderList();
      } else {
        this.getOrderList();
      }
    },
    downPage() {
      // 下一页
      if (this.tableData.length == 10) {
        this.page++;
        console.log(this.page);
        this.getOrderList();
        console.log(this.tableData.length);
        if (this.tableData.length == 0) {
          this.$message("请添加新品牌");
          this.page--;
          this.getOrderList();
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 10px 55px 30px 0;
  height: calc(100vh - 102px);
  .bodycontent {
    position: relative;
    padding: 0px 27px 0;
    font-size: 14px;
    height: 96%;
    border: 1px solid #f1f1f1;
    box-shadow: 0 0 3px #f1f1f1;
    overflow: auto;
    .option {
      height: 79px;
      line-height: 79px;
    }
    .edit_button {
      height: 7%;
    }
    // table
    .el-table {
      box-shadow: 0 0 3px #f1f1f1;
      height: 78%;
      padding-left: 20px;
    }
    //分页
    .Otherpage {
      height: 34px;
      width: 200px;
      position: absolute;
      bottom: 0;
      .changePage {
        height: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        div {
          height: 100%;
          width: 30%;
          text-align: center;
          line-height: 34px;
        }
        .btnColor {
          background: #b0b5bb30;
        }
      }
    }
  }
}
</style>
